import httpClient from "@plugins/http";
import { ApiResponse } from "@apis/api.ts";
import { MediaMetadata } from "@plugins/media/types.ts";

export interface PreCreateInlineUgcPayload {
  resourceId?: number;
  resourceUuid?: string;
  resourceType?: string;
  fileName?: string;
}

export interface UgcContextParams {
  uuid: string;
  contextType?: string;
  contextUuid?: string;
}

const downloadMediaObject = (params) => {
  const queryParams = new URLSearchParams();
  if (params.contextUuid && params.contextType) {
    queryParams.append("contextType", params.contextType);
    queryParams.append("contextUuid", params.contextUuid);
  }
  return httpClient.get(`/apis/ugc/download/${params.uuid}`, { params: queryParams });
};

const createInlineUgc = (requestData) => {
  return httpClient.post(`/apis/ugc/inline/create`, requestData);
};

const saveInlineUgc = (uuid, requestData) => {
  return httpClient.post(`/apis/ugc/inline/edit/${uuid}`, requestData);
};

/**
 * Create a UGC placeholder record (no fileUuid yet).
 * Called before the file upload so resourceType+resourceUuid can be stored
 * in Valkey at generate-scan-url time for FileMoveJobListenerImpl routing.
 */
const preCreateInlineUgc = (
  requestData: PreCreateInlineUgcPayload,
): Promise<ApiResponse<string>> => {
  return httpClient.post(`/apis/ugc/inline/pre-create`, requestData);
};

const getMetaData = (params): Promise<ApiResponse<MediaMetadata>> => {
  const queryParams = new URLSearchParams();
  if (params.contextUuid && params.contextType) {
    queryParams.append("contextType", params.contextType);
    queryParams.append("contextUuid", params.contextUuid);
  }
  return httpClient.get(`/apis/ugc/get-meta/${params.uuid}`, { params: queryParams });
};

const getSeReferenceUrl = (params: UgcContextParams): Promise<ApiResponse<string>> => {
  const queryParams = new URLSearchParams();
  if (params.contextUuid && params.contextType) {
    queryParams.append("contextType", params.contextType);
    queryParams.append("contextUuid", params.contextUuid);
  }
  return httpClient.get<ApiResponse<string>, ApiResponse<string>>(
    `/apis/ugc/se-reference/${encodeURIComponent(params.uuid)}`,
    {
      params: queryParams,
    },
  );
};

export default {
  downloadMediaObject,
  createInlineUgc,
  saveInlineUgc,
  preCreateInlineUgc,
  getMetaData,
  getSeReferenceUrl,
};
